import React from 'react';
import { CustomerQueue } from '../../../types/models/customer-queue';

interface CustomerQueueItemProps {
  queue: CustomerQueue;
}

export function CustomerQueueItem(props: CustomerQueueItemProps) {
  return (
    <>
      <div>
        <span>
          {props.queue.serviceProviderName} - {props.queue.queueName}
        </span>
        {/* <span>{props.queue.id}</span> */}
        {/* <span>{props.queue.serviceProviderId}</span> */}
      </div>
    </>
  );
}
